import { useEffect } from 'react'

import { passesCategoryFilter } from '../vault.helpers'

type Args = {
  media: any[]
  activeCategory: any[]
  postsGrouped: string | boolean
  setCategoryExistingPosts: (ids: string[]) => void
}

export function useCategoryExistingPosts({
  media,
  activeCategory, 
  postsGrouped,
  setCategoryExistingPosts,
}: Args) {
  useEffect(() => {
    const cid = activeCategory?.[0]?.id ?? null
    if (cid == null) {
      setCategoryExistingPosts([])
      return
    }

    const ids = (Array.isArray(media) ? media : [])
      .filter((it: any) => passesCategoryFilter(it, cid, !!postsGrouped))
      .map((it: any) => it.id)

    setCategoryExistingPosts(ids)
  }, [media, activeCategory, postsGrouped, setCategoryExistingPosts])
}
